/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentPublishSocialVersionMutationRequest, ContentPublishSocialVersionMutationResponse, ContentPublishSocialVersionPathParams } from "../models/ContentPublishSocialVersion";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { contentPublishSocialVersion } from "../axios/contentPublishSocialVersion";
import { useMutation } from "@tanstack/react-query";

export const contentPublishSocialVersionMutationKey = () => ["content-ai-api", { url: '/contents/:id/social-version/:platform/publish' }] as const

export type ContentPublishSocialVersionMutationKey = ReturnType<typeof contentPublishSocialVersionMutationKey>

/**
 * @summary Publish social version to platform
 * {@link /contents/:id/social-version/:platform/publish}
 */
export function useContentPublishSocialVersion<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentPublishSocialVersionMutationResponse, ResponseErrorConfig<Error>, {id: ContentPublishSocialVersionPathParams["id"], platform: ContentPublishSocialVersionPathParams["platform"], data: ContentPublishSocialVersionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentPublishSocialVersionMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? contentPublishSocialVersionMutationKey()

  return useMutation<ContentPublishSocialVersionMutationResponse, ResponseErrorConfig<Error>, {id: ContentPublishSocialVersionPathParams["id"], platform: ContentPublishSocialVersionPathParams["platform"], data: ContentPublishSocialVersionMutationRequest}, TContext>({
    mutationFn: async({ id, platform, data }) => {
      return contentPublishSocialVersion(id, platform, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}